import { createContext, useContext, useState } from 'react';

// كنديرو Create Context
const SearchContext = createContext();

// Provider
export function SearchProvider({ children }) {
  const [query, setQuery] = useState('');
  const [specialties, setSpecialties] = useState([]);
  const [filters, setFilters] = useState({
    specialty: '',
    country: '',
    city: '',
    area: '',
    gender: '',
  });

  const updateFilters = (newFilters) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };

  const clearFilters = () => {
    setFilters({
      specialty: '',
      country: '',
      city: '',
      area: '',
      gender: '',
    });
  };

  return (
    <SearchContext.Provider
      value={{
        query,
        setQuery,
        specialties,
        setSpecialties,
        filters,
        updateFilters,
        clearFilters,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
}

// Custom hook 
export function useSearch() {
  return useContext(SearchContext);
}
